
const MONTH_FORMAT = new Intl.DateTimeFormat(undefined, { month: 'long' });
const DAY_FORMAT = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'long' });
const DAY_NUM_FORMAT = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'numeric' });
const DAY_OF_MONTH_FORMAT = new Intl.DateTimeFormat(undefined, { day: 'numeric' });
const WEEKDAY_FORMAT = new Intl.DateTimeFormat(undefined, { weekday: 'long' });
const WEEKDAY_SHORT_FORMAT = new Intl.DateTimeFormat(undefined, { weekday: 'short' });
const DAY_HEADER_TINY = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric' });
const DAY_HEADER_SHORT = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'numeric' });
const DAY_HEADER_LONG = new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });

export function monthName(date: Date): string {
	return MONTH_FORMAT.format(date);
}
export function dayName(date: Date): string {
	return DAY_FORMAT.format(date);
}
export function dayNumeric(date: Date): string {
	return DAY_NUM_FORMAT.format(date);
}
export function dayOfMonth(date: Date): string {
	return DAY_OF_MONTH_FORMAT.format(date);
}
export function weekdayName(date: Date): string {
	return WEEKDAY_FORMAT.format(date);
}
export function weekdayShortName(date: Date): string {
	return WEEKDAY_SHORT_FORMAT.format(date);
}

export function dayHeaderLong(date:Date):string {
	return DAY_HEADER_LONG.format(date);
}

export function dayHeaderShort(date:Date):string {
	return DAY_HEADER_SHORT.format(date);
}
export function dayHeaderTiny(date:Date):string {
	return DAY_HEADER_TINY.format(date);
}